/**
 * The zone terminal: the map board a raid is picked off.
 *
 * The largest of the four and the only one that faces the door, because it is the one station the
 * hub exists to be left through.
 *
 * Inert. Choosing a zone and dropping into it is #212's, and this is a board with nothing on it.
 */

import { stationPart } from '@/modes/hub/sim/stations/stationParts';
import type { HubStation } from '@/modes/hub/sim/stations/hubStationContract';
import type { StationFrame } from '@/modes/hub/sim/stations/stationParts';
import { vec3 } from '@/sim/vec3';

const FRAME: StationFrame = {
  kindId: 'zoneTerminal',
  position: vec3(11, 0, 4),
  yawDegrees: 90,
};

export const ZONE_TERMINAL_STATION: HubStation = {
  ...FRAME,
  colliders: [
    stationPart(FRAME, 'plinth', vec3(0, 0.4, -0.4), vec3(1.4, 0.4, 0.4), 'weatheredConcrete'),
    // Head height and wide: a board somebody stands in front of, not a monitor they lean over.
    stationPart(FRAME, 'board', vec3(0, 1.5, 0.05), vec3(1.4, 0.9, 0.08), 'armourSteel'),
    stationPart(FRAME, 'frame', vec3(0, 1.5, 0.16), vec3(1.5, 1, 0.05), 'rustedSteel'),
  ],
};
